export const getBandLabel = (band,needPrefix=false,prefixText='B') => {
  if(needPrefix){
    if(band === 'Contractor') return band;
    return `${prefixText}${band}`
  }
  if (band === -1) return 'Contractor';
  return band;
}